import React, { ReactNode } from 'react';
import './Title.scss';
import Breadcrumbs, { BreadcrumbItem } from '../breadcrumbs/Breadcrumbs';
import { Skeleton } from 'primereact/skeleton';

interface TitleProps {
  title?: ReactNode;
  titleStyle?: string;
  /** Extra class on the title row (e.g. `capitalize`). */
  titleClassName?: string;
  isBaseCategory?: boolean;
  btnLabel?: string;
  showStatusDot?: boolean;
  showLoader?: boolean;
  children?: ReactNode;
  childrenOnMain?: ReactNode;
  /** Jawny trail breadcrumbs, gdy ścieżka nie opisuje hierarchii (patrz `Breadcrumbs`). */
  breadcrumbs?: BreadcrumbItem[];
}

export interface CategoryData {
  name: string;
  link?: string;
}

const Title: React.FC<TitleProps> = ({
  title,
  titleStyle,
  titleClassName,
  isBaseCategory = true,
  showLoader = false,
  children,
  childrenOnMain,
  breadcrumbs,
}) => {
  return (
    <div className="title-box">
      <div className="title-box__title">
        {showLoader ? (
          <Skeleton className="skeleton--title">
            <span />
          </Skeleton>
        ) : (
          <div className="title-box__nav">
            {!isBaseCategory && <Breadcrumbs items={breadcrumbs} />}
            <div className="title-box__row">
              {title && (
                <div className={`title-box__row-title${titleClassName ? ` ${titleClassName}` : ''}`}>
                  {titleStyle && <span className={titleStyle} />}
                  {title}
                </div>
              )}
              {childrenOnMain != null && <span className="title-box__main-child">{childrenOnMain}</span>}
            </div>
          </div>
        )}
      </div>
      {showLoader ? (
        <Skeleton className="skeleton--btn">
          <span></span>
        </Skeleton>
      ) : (
        children !== null && <div className="title-box__action">{children}</div>
      )}
    </div>
  );
};

export default Title;
